import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface PreRecognitionSiteLengthProps {
  preRecognitionSiteLength: number | null;
  updatePreRecognitionSiteLength: (preRecognitionSiteLength: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input to set the pre-recognition site length for a Golden Gate assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.preRecognitionSiteLength The length in base pairs of the pre-recognition site.
 * @param {function} props.updatePreRecognitionSiteLength A function that takes a new pre-recognition site length and uses it to update state.
 * @constructor
 */
export function PreRecognitionSiteLength(props: PreRecognitionSiteLengthProps): JSX.Element {
  return (
    <InputWrapper
      id="preRecognitionSiteLength"
      label="Pre-recognition site - length (bp)"
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.preRecognitionSiteLength}
        min={0}
        required={true}
        onChange={(e) => {
          props.updatePreRecognitionSiteLength(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
